// Copyright (C) 2021 Bystronic Laser AG

export enum Measurements {
  Unknown = 0,
  Metric = 1,
  Imperial = 2,
}
